import axios from "axios";

export default axios.create({
  baseURL: "https://api.civixapp.com/api/v1",
  // baseURL: "http://44.208.32.100:4000/api/v1",
  // baseURL: "http://192.168.29.136:4000/api/v1",
});
